import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './config/config-amplify'
import App from './App'
import { createMuiTheme } from '@material-ui/core/styles'
import { ThemeProvider } from '@material-ui/styles'
import { shouldEnableNewRelic, getNewRelicConfig } from './newrelic/newrelic-config'

// Initialize New Relic Browser Agent
if (shouldEnableNewRelic()) {
  import('@newrelic/browser-agent')
    .then(({ BrowserAgent }) => {
      new BrowserAgent(getNewRelicConfig())
    })
    .catch(err => {
      console.warn('Failed to initialize New Relic Browser Agent:', err)
    })
}

const theme = createMuiTheme({
  props: {
    MuiTypography: {
      variantMapping: {
        h3: 'label',
      },
    },
  },
})

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <App />
  </ThemeProvider>,
  document.getElementById('root'),
)

